<template>
  <div class="config-page">
    <van-nav-bar left-arrow class="crystal-nav" @click-left="gotohome">
      <template #left>
        <van-icon name="arrow-left" size="20px" color="#475569" />
      </template>
      <template #title>
        <span class="nav-title">参数设置</span>
      </template>
    </van-nav-bar>

    <div class="content-area">
      <van-tabs v-model="activeTab" color="#2dd4bf" title-active-color="#0d9488" class="crystal-tabs">
        <van-tab title="补水设置">
          <div class="tab-content">
            <div class="config-block">
              <div class="config-item">
                <span class="config-label">补水开关</span>
                <van-switch v-model="config_re[0]" size="22" />
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <span class="config-label">补水间隔（分钟）</span>
                <div class="config-stepper">
                  <van-stepper v-model="config_re[1]" min="1" max="99" step="1" />
                </div>
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <span class="config-label">补水超时（分钟）</span>
                <div class="config-stepper">
                  <van-stepper v-model="config_re[2]" min="0" max="5" step="1" />
                </div>
              </div>
            </div>
            <div class="config-save-wrap">
              <button class="save-btn" :disabled="loading" @click="saveConfig">
                <span v-if="loading" class="save-btn-loading"></span>
                <span>{{ loading ? '保存中...' : '保存补水设置' }}</span>
              </button>
            </div>
          </div>
        </van-tab>

        <van-tab title="换水设置">
          <div class="tab-content">
            <div class="config-block">
              <div class="config-item">
                <span class="config-label">换水模式</span>
                <div class="config-select">
                  <van-radio-group v-model="config_wc[0]" direction="horizontal">
                    <van-radio name="0" class="crystal-radio">间隔模式</van-radio>
                    <van-radio name="1" class="crystal-radio">定时预约</van-radio>
                    <van-radio name="2" class="crystal-radio">手动模式</van-radio>
                  </van-radio-group>
                </div>
              </div>

              <template v-if="isWcInterval">
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">换水间隔（小时）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[1]" min="1" max="168" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">排水超时（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[2]" min="0" max="99" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">补水超时（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[3]" min="0" max="30" step="1" />
                  </div>
                </div>
              </template>

              <template v-if="isWcScheduled">
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">排水超时（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[2]" min="0" max="99" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">补水超时（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[3]" min="0" max="30" step="1" />
                  </div>
                </div>

                <!-- 预约3组：每组 = 星期多选 + 时间（未选任何星期 = 该组禁用） -->
                <template v-for="g in [0, 1, 2]">
                  <div :key="'d' + g" class="config-divider"></div>
                  <div :key="'g' + g" class="rtc-group">
                    <div class="rtc-group-header">
                      <span class="rtc-group-title">预约组{{ g + 1 }}</span>
                      <div class="rtc-group-right">
                        <span class="rtc-group-status"
                          :class="(config_wc[4 + g * 4] === 1) ? 'rtc-group-status--on' : ''">
                          {{ (config_wc[4 + g * 4] === 1) ? '已启用' : '未启用' }}
                        </span>
                        <van-switch :value="config_wc[4 + g * 4] === 1" size="18" @change="setRtcEnable(g, $event)" />
                      </div>
                    </div>
                    <div class="config-item config-item--full">
                      <div class="config-weekdays">
                        <span v-for="(day, idx) in weekdays" :key="'wd' + g + idx" class="weekday-tag"
                          :class="{ 'weekday-active': (config_wc[5 + g * 4] >> idx) & 1 }"
                          @click="toggleWeekday(g, idx)">
                          {{ day }}
                        </span>
                      </div>
                    </div>
                    <div class="config-divider"></div>
                    <div class="config-item">
                      <span class="config-label">时间</span>
                      <div class="time-picker-trigger" @click="openTimePicker(g)">
                        <span class="time-picker-text">{{ rtcTimeDisplay(g) }}</span>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M11 5L7 9L3 5" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </template>
              </template>

              <template v-if="isWcManual">
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">排水超时（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[2]" min="0" max="99" step="1" />
                  </div>
                </div>
                <div class="config-divider"></div>
                <div class="config-item">
                  <span class="config-label">补水超时（分钟）</span>
                  <div class="config-stepper">
                    <van-stepper v-model="config_wc[3]" min="0" max="30" step="1" />
                  </div>
                </div>
              </template>
            </div>
            <div class="config-save-wrap">
              <button class="save-btn" :disabled="loading" @click="saveConfig">
                <span v-if="loading" class="save-btn-loading"></span>
                <span>{{ loading ? '保存中...' : '保存换水设置' }}</span>
              </button>
            </div>
          </div>
        </van-tab>

        <van-tab title="系统设置">
          <div class="tab-content">
            <div class="config-block">
              <div class="config-item">
                <span class="config-label">维护时长（分钟）</span>
                <div class="config-stepper">
                  <van-stepper v-model="config_sys[0]" min="1" max="99" step="1" />
                </div>
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <span class="config-label">无水检测</span>
                <van-switch v-model="config_sys[1]" size="22" />
              </div>
              <div class="config-divider"></div>
              <div class="config-item">
                <span class="config-label">蜂鸣器报警</span>
                <van-switch v-model="config_sys[2]" size="22" />
              </div>
            </div>
            <div class="config-save-wrap">
              <button class="save-btn" :disabled="loading" @click="saveConfig">
                <span v-if="loading" class="save-btn-loading"></span>
                <span>{{ loading ? '保存中...' : '保存系统设置' }}</span>
              </button>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <van-popup v-model="showTimePicker" position="bottom" round>
      <van-datetime-picker v-model="timePickerCurrent" type="time" :min-hour="0" :max-hour="23" :min-minute="0"
        :max-minute="59" @confirm="onTimeConfirm" @cancel="showTimePicker = false" />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "KD3Config",
  data() {
    return {
      activeTab: 0,
      did: this.$route.query.did,
      weekdays: ["一", "二", "三", "四", "五", "六", "日"],
      config_re: [false, 30, 3],
      /* wc[16] = [模式, 间隔, 排水超时, 补水超时, 预约组1(开关/星期/时/分), 组2(开关/星期/时/分), 组3(开关/星期/时/分)] */
      config_wc: [0, 24, 10, 0, 1, 127, 8, 0, 0, 0, 20, 0, 0, 0, 0, 0],
      config_sys: [30, false, true],
      loading: false,
      showTimePicker: false,
      currentRtcGroup: 0,        /* 时间选择器当前编辑的预约组 0~2 */
      timePickerCurrent: "08:00",
    };
  },
  computed: {
    isWcInterval() {
      return String(this.config_wc[0]) === "0";
    },
    isWcScheduled() {
      return String(this.config_wc[0]) === "1";
    },
    isWcManual() {
      return String(this.config_wc[0]) === "2";
    },
  },
  watch: {
    config_wc: {
      handler(val) {
        if (val && val.length >= 13) {
          var h = String(Number(val[6 + this.currentRtcGroup * 4]) || 0).padStart(2, "0");
          var m = String(Number(val[7 + this.currentRtcGroup * 4]) || 0).padStart(2, "0");
          this.timePickerCurrent = h + ":" + m;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    /* 指定预约组的时间显示 时:分 */
    rtcTimeDisplay(g) {
      var h = String(Number(this.config_wc[6 + g * 4]) || 0).padStart(2, "0");
      var m = String(Number(this.config_wc[7 + g * 4]) || 0).padStart(2, "0");
      return h + ":" + m;
    },
    /* 打开时间选择器并记录当前编辑的预约组 */
    openTimePicker(g) {
      this.currentRtcGroup = g;
      var h = String(Number(this.config_wc[6 + g * 4]) || 0).padStart(2, "0");
      var m = String(Number(this.config_wc[7 + g * 4]) || 0).padStart(2, "0");
      this.timePickerCurrent = h + ":" + m;
      this.showTimePicker = true;
    },
    GetConfig() {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: this.did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            var cfg = response.data.config;
            if (cfg) {
              if (cfg.re) {
                var re = cfg.re.slice();
                re[0] = Boolean(re[0]);
                this.config_re = re;
              }
              if (cfg.wc) {
                var wc = cfg.wc.slice();
                wc[0] = String(wc[0]);
                /* 补齐到 13 项（预约3组），防止旧缓存/旧固件数组不足导致 undefined */
                while (wc.length < 16) wc.push(0);
                this.config_wc = wc;
              }
              if (cfg.sys) {
                var arr = cfg.sys.slice();
                while (arr.length < 3) arr.push(0);
                arr[1] = Boolean(arr[1]);
                arr[2] = Boolean(arr[2]);
                this.config_sys = arr;
              }
            }
          }
        });
    },
    saveConfig() {
      this.loading = true;
      const qs = require("qs");
      var configData = {};
      if (this.activeTab === 0) {
        configData = {
          replenish_enable: this.config_re[0] ? 1 : 0,
          replenish_Interval: this.config_re[1],
          replenish_timeout: this.config_re[2],
        };
      } else if (this.activeTab === 1) {
        configData = {
          wc_mode: Number(this.config_wc[0]),
          wc_interval: this.config_wc[1],
          drain_time: this.config_wc[2],
          wc_replenish_timeout: this.config_wc[3],
          /* 预约3组：开关/星期/时/分 */
          wc_rtc_enable1: this.config_wc[4],
          wc_cycle_week1: this.config_wc[5],
          wc_fixed_hour1: this.config_wc[6],
          wc_fixed_minute1: this.config_wc[7],
          wc_rtc_enable2: this.config_wc[8],
          wc_cycle_week2: this.config_wc[9],
          wc_fixed_hour2: this.config_wc[10],
          wc_fixed_minute2: this.config_wc[11],
          wc_rtc_enable3: this.config_wc[12],
          wc_cycle_week3: this.config_wc[13],
          wc_fixed_hour3: this.config_wc[14],
          wc_fixed_minute3: this.config_wc[15],
        };
      } else if (this.activeTab === 2) {
        configData = {
          maintain_time: this.config_sys[0],
          no_water: this.config_sys[1] ? 1 : 0,
          alarm_beep: this.config_sys[2] ? 1 : 0,
        };
      }
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.did,
          d_type: "KD-3",
          config: JSON.stringify(configData),
        }))
        .then((response) => {
          this.loading = false;
          if (response.data.error_code === 0) {
            this.$toast.success("设置已保存");
          } else {
            this.$toast.fail("保存失败");
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$toast.fail("保存失败");
        });
    },
    onTimeConfirm() {
      var parts = String(this.timePickerCurrent).split(":");
      this.$set(this.config_wc, 6 + this.currentRtcGroup * 4, parseInt(parts[0], 10) || 0);
      this.$set(this.config_wc, 7 + this.currentRtcGroup * 4, parseInt(parts[1], 10) || 0);
      this.showTimePicker = false;
    },
    toggleWeekday(g, idx) {
      var val = this.config_wc[5 + g * 4] ^ (1 << idx);
      this.$set(this.config_wc, 5 + g * 4, val);
    },
    /* 设置预约组的独立开关 */
    setRtcEnable(g, val) {
      this.$set(this.config_wc, 4 + g * 4, val ? 1 : 0);
    },
    gotohome() {
      this.$router.go(-1);
    },
    setDefaultConfig(re, wc, sys) {
      if (re) this.config_re = re;
      if (wc) this.config_wc = wc;
      if (sys) this.config_sys = sys;
    },
  },
  mounted() {
    this.GetConfig();
  },
};
</script>

<style>
.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.crystal-tabs .van-tabs__wrap {
  background: #ffffff;
}

.crystal-tabs .van-tab {
  font-weight: 500;
}

.crystal-radio .van-radio__label {
  font-size: 13px;
}
</style>

<style scoped>
.config-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
}

.content-area {
  padding: 12px;
}

.tab-content {
  padding-top: 8px;
}

.config-block {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  overflow: hidden;
}

.config-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  min-height: 22px;
  gap: 12px;
}

.config-item--full {
  justify-content: center;
  padding: 14px 12px;
}

.config-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  flex-shrink: 0;
}

.config-stepper {
  flex-shrink: 0;
}

.config-select {
  flex-shrink: 0;
}

.config-weekdays {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-width: 320px;
  gap: 4px;
}

.weekday-tag {
  width: 36px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  background: #f1f5f9;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s;
  user-select: none;
}

.weekday-tag:active {
  transform: scale(0.9);
}

.weekday-active {
  background: #2dd4bf;
  color: #fff;
  box-shadow: 0 2px 6px rgba(45, 212, 191, 0.25);
}

/* 预约组卡片 */
.rtc-group {
  background: #f8fafc;
  border-radius: 10px;
  padding: 2px 4px 0;
  margin: 8px 10px;
}

.rtc-group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 0;
}

.rtc-group-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.rtc-group-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rtc-group-status {
  font-size: 11px;
  color: #94a3b8;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 6px;
}

.rtc-group-status--on {
  color: #0d9488;
  background: rgba(45, 212, 191, 0.12);
}

.config-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0 16px;
}

.config-save-wrap {
  padding: 16px 0 24px;
  display: flex;
  justify-content: center;
}

.save-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: transform 0.15s, opacity 0.15s;
  box-shadow: 0 4px 12px rgba(45, 212, 191, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.save-btn:active {
  transform: scale(0.98);
  opacity: 0.9;
}

.save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.save-btn-loading {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.time-picker-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: border-color 0.2s;
  background: #f8fafc;
}

.time-picker-trigger:active {
  border-color: #2dd4bf;
}

.time-picker-text {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  min-width: 44px;
  text-align: center;
}
</style>